if (!window.Eurus.loadedScript.has('quick-order-list.js')) {
  window.Eurus.loadedScript.add('quick-order-list.js');

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.store('xQuickOrderList', {
        currentPage: 1,
        sectionId: '',
        productUrl: '',
        allListLoading: false,
        loading: false,
        suppressCartSync: false,
        cachedResults: {},
        collapsedGroups: {},
        groupPages: {},
        loadingMore: {},
        drafts: {},
        errorLines: {},
        addAllLoading: false,
        get dirtyCount() {
          return Object.keys(this.drafts).length;
        },
        get errorLineCount() {
          return Object.keys(this.errorLines).length;
        },
        get draftTotalQuantity() {
          return Object.values(this.drafts).reduce((total, item) => total + item.qty, 0);
        },
        get draftTotalPrice() {
          return Object.values(this.drafts).reduce((total, item) => total + item.lineTotal, 0);
        },
        setErrorLine(variantId, hasError) {
          if (hasError) {
            this.errorLines[variantId] = true;
          } else {
            delete this.errorLines[variantId];
          }
        },
        groupTotal(productId) {
          return Object.values(this.drafts).reduce((total, item) => item.productId == productId ? total + item.lineTotal : total, 0);
        },
        setDraft(variantId, qty, lineTotal, productId) {
          if (qty > 0) {
            this.drafts[variantId] = { qty: qty, lineTotal: lineTotal, productId: productId };
          } else {
            delete this.drafts[variantId];
          }
        },
        clearDrafts() {
          this.drafts = {};
          this.errorLines = {};
        },
        removeAll() {
          if (this.dirtyCount === 0 && this.errorLineCount === 0) return;
          this.clearDrafts();
          document.dispatchEvent(new CustomEvent('eurus:quick-order-list:drafts-cleared'));
        },
        addAllToCart() {
          const items = Object.entries(this.drafts).map(([id, item]) => ({ id, quantity: item.qty }));
          if (items.length === 0 || this.addAllLoading) return;
          this.addAllLoading = true;
          this.allListLoading = true;
          fetch(`${Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: items,
              sections: Alpine.store('xCartHelper').getSectionsToRender().map((s) => s.id),
              sections_url: window.location.pathname
            })
          })
            .then((response) => response.json())
            .then((response) => {
              if (response.status == '422') {
                document.dispatchEvent(new CustomEvent('eurus:product:add-failed', {
                  detail: { errorMessage: response.description || response.message }
                }));
                return;
              }
              Alpine.store('xPopup').close();
              if (response.sections) Alpine.store('xCartHelper').reRenderSections(response.sections);
              Alpine.store('xCartHelper').currentItemCount = parseInt(document.getElementById('cart-icon-bubble').innerHTML);
              if (Alpine.store('xCartNoti') && Alpine.store('xCartNoti').enable) {
                Alpine.store('xCartNoti').setItem(response);
              } else {
                Alpine.store('xMiniCart')?.openCart();
              }
              document.dispatchEvent(new CustomEvent('eurus:product:added', { detail: { product: response } }));
              const added = Object.keys(this.drafts);
              this.clearDrafts();
              added.forEach((id) => {
                document.getElementById(`quick-order-list-quantity-${id}`)?.setAttribute('value', 0);
                const inputs = [
                  document.getElementById(`quick-order-list-quantity-${id}`),
                  document.getElementById(`quick-order-list-quantity-mobile-${id}`)
                ];
                inputs.forEach((input) => { if (input) input.value = 0; });
              });
              document.dispatchEvent(new CustomEvent('eurus:quick-order-list:drafts-cleared'));
              this.suppressCartSync = true;
              document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
              this.reloadPage();
            })
            .catch((error) => {
              document.dispatchEvent(new CustomEvent('eurus:product:add-failed', { detail: { errorMessage: error } }));
              console.error('Error:', error);
            })
            .finally(() => {
              this.addAllLoading = false;
              this.allListLoading = false;
            });
        },
        init() {
          document.addEventListener(`eurus:cart:items-changed`, () => {
            if (this.suppressCartSync) {
              this.suppressCartSync = false;
              return;
            }
            this.reloadPage();
          });
        },
        initPagination(sectionId, productUrl) {
          this.sectionId = sectionId;
          this.productUrl = productUrl;
        },
        toggleGroup(id) {
          this.collapsedGroups[id] = !this.collapsedGroups[id];
        },
        isCollapsed(id) {
          return !!this.collapsedGroups[id];
        },
        _sectionLink(pageParam, page) {
          return `${this.productUrl.split('?')[0]}?${pageParam}=${page}&section_id=${this.sectionId}`;
        },
        _fetchSection(link, options) {
          return fetch(link, options)
            .then((response) => response.text())
            .then((responseText) => new DOMParser().parseFromString(responseText, 'text/html'));
        },
        loadMoreVariants(productId, nextPage, pageParam) {
          nextPage = Number(nextPage) || 2;
          if (this.loadingMore[productId]) return Promise.resolve();
          if (((this.groupPages[productId] || {}).page || 1) >= nextPage) return Promise.resolve();
          this.loadingMore[productId] = true;

          const link = this._sectionLink(pageParam, nextPage);
          return this._fetchSection(link)
            .then((html) => {
              this.cachedResults[link] = html;
              const srcBody = html.getElementById(`qol-variants-${productId}`);
              const desBody = document.getElementById(`qol-variants-${productId}`);
              if (!srcBody || !desBody) return;
              const oldSentinel = desBody.querySelector('.qol-sentinel');
              Array.from(srcBody.children).forEach((row) => {
                if (oldSentinel) {
                  desBody.insertBefore(row, oldSentinel);
                } else {
                  desBody.appendChild(row);
                }
              });
              if (oldSentinel) oldSentinel.remove();
              this.groupPages[productId] = { page: nextPage, param: pageParam };
            })
            .catch((err) => {
              if (err.name !== 'AbortError') {
                console.error(err);
              }
            })
            .finally(() => {
              this.loadingMore[productId] = false;
            });
        },
        refreshLine(variantId) {
          this.cachedResults = {};
          const row = document.getElementById(`quick-order-list-item-${variantId}`);
          if (!row) return Promise.resolve();
          const productId = row.dataset.qolProduct;
          const link = this._sectionLink(row.dataset.qolPageParam || 'page', row.dataset.qolPage || 1);
          return this._fetchSection(link)
            .then((html) => {
              const newRow = html.getElementById(`quick-order-list-item-${variantId}`);
              const currentRow = document.getElementById(`quick-order-list-item-${variantId}`);
              if (newRow && currentRow) {
                currentRow.replaceWith(newRow);
              }
              [`qol-group-total-${productId}`, `qol-group-total-mobile-${productId}`, 'QuickOrderListSummary'].forEach((id) => {
                const src = html.getElementById(id);
                const des = document.getElementById(id);
                if (src && des) {
                  des.innerHTML = src.innerHTML;
                }
              });
            })
            .catch((err) => {
              if (err.name !== 'AbortError') {
                console.error(err);
              }
            });
        },
        renderPage(html) {
          const src = html.getElementById('x-quick-order-list-container');
          const des = document.getElementById('x-quick-order-list-container');
          if (src && des) {
            des.innerHTML = src.innerHTML;
          }
        },
        async reloadPage() {
          const restore = { ...this.groupPages };
          this.groupPages = {};
          this.cachedResults = {};
          await this.loadPage(this.currentPage, true, false);
          for (const [productId, info] of Object.entries(restore)) {
            for (let p = 2; p <= info.page; p++) {
              await this.loadMoreVariants(productId, p, info.param);
            }
          }
        },
        _scrollToTop() {
          Alpine.store("xHeaderMenu")?.suppressScroll?.(2000);
          document.getElementById('x-quick-order-list-container').parentElement.scrollIntoView({ behavior: "smooth" });
        },
        loadPage(pageParam, reload = false, scroll = true) {
          this.loading = true;
          const link = this._sectionLink('page', Number(pageParam));
          Alpine.store('xHelper').cancelRequest('eurus:quick_order_list_request');
          if (this.cachedResults[link] && !reload) {
            this.currentPage = Number(pageParam);
            if (scroll) this._scrollToTop();
            this.loading = false;
            this.renderPage(this.cachedResults[link]);
            return Promise.resolve();
          }
          const controller = new AbortController();
          Alpine.store('xHelper').requestControllers.set('eurus:quick_order_list_request', controller);
          return this._fetchSection(link, { signal: controller.signal })
            .then((html) => {
              this.renderPage(html);
              this.cachedResults[link] = html;
            })
            .catch((err) => {
              if (err.name !== 'AbortError') {
                console.error(err);
              }
            })
            .finally(() => {
              this.currentPage = Number(pageParam);
              if (scroll) this._scrollToTop();
              this.loading = false;
            });
        },
      });

      Alpine.data('xQuickOrderListItem', (variant, config, stockError) => ({
        draft: 0,
        hasError: false,
        init() {
          this.draft = 0;
          document.addEventListener('eurus:quick-order-list:drafts-cleared', () => {
            this.draft = 0;
            this._setInputs(0);
            this._clearErrorMessage(variant.id);
          });
        },
        _inputs() {
          return [
            document.getElementById(`quick-order-list-quantity-${variant.id}`),
            document.getElementById(`quick-order-list-quantity-mobile-${variant.id}`)
          ];
        },
        _setInputs(value) {
          this._inputs().forEach((input) => {
            if (input) input.value = value;
          });
        },
        _unitPrice(qty) {
          let price = config.price;
          const breaks = config.priceBreaks || [];
          for (let i = 0; i < breaks.length; i++) {
            if (qty >= breaks[i].min) price = breaks[i].price;
          }
          return price;
        },
        _lineTotal(qty) {
          return qty * this._unitPrice(qty);
        },
        _setDraft(qty) {
          this.draft = qty;
          this._setInputs(qty);
          Alpine.store('xQuickOrderList').setDraft(variant.id, qty, this._lineTotal(qty), config.productId);
        },
        onChangeQuantity(e, inCart, el) {
          const qty = parseInt(el.value) || 0;
          this._setInputs(qty);
          if (qty === 0) {
            this._clearErrorMessage(variant.id);
            this._setDraft(0);
            return;
          }
          const error = this._validate(qty);
          if (error) {
            this.draft = qty;
            Alpine.store('xQuickOrderList').setDraft(variant.id, 0);
            this._addErrorMessage(variant.id, error);
            return;
          }
          this._clearErrorMessage(variant.id);
          this._setDraft(qty);
        },
        _validate(qty) {
          const { min, max, step } = this._rule();
          if (min > 1 && qty < min) return config.msgMin;
          if (step > 1 && (qty - min) % step !== 0) return config.msgMultiple;
          if (max != null && qty > max) return config.msgMax;
          if (this._exceedsStock(qty)) return stockError;
          return null;
        },
        removeItem() {
          this._clearErrorMessage(variant.id);
          this._setDraft(0);
        },
        minus() {
          const current = parseInt(this._inputs()[0]?.value) || 0;
          if (current <= 0) {
            this._clearErrorMessage(variant.id);
            this._setDraft(0);
            return;
          }
          const { min, step } = this._rule();
          let next = current - step;
          if (next < min) next = 0;
          this.draft = next;
          this._setInputs(next);
          const error = next > 0 ? this._validate(next) : null;
          if (error) {
            Alpine.store('xQuickOrderList').setDraft(variant.id, 0);
            this._addErrorMessage(variant.id, error);
            return;
          }
          this._clearErrorMessage(variant.id);
          this._setDraft(next);
        },
        plus() {
          const { min, step } = this._rule();
          const current = parseInt(this._inputs()[0]?.value) || 0;
          const next = current <= 0 ? min : current + step;
          this.draft = next;
          this._setInputs(next);
          const error = this._validate(next);
          if (error) {
            Alpine.store('xQuickOrderList').setDraft(variant.id, 0);
            this._addErrorMessage(variant.id, error);
            return;
          }
          this._clearErrorMessage(variant.id);
          this._setDraft(next);
        },
        handleKeydown(evt, el) {
          if (evt.key !== 'Enter') return;
          evt.preventDefault();
          el.blur();
          el.focus();
        },
        invalid(el) {
          const number = parseFloat(el.value);
          if (!Number.isInteger(number) || number < 0) {
            el.value = 0;
          }
        },
        _exceedsStock(qty) {
          if (!config.checkStock) return false;
          return parseInt(qty) > config.stockLimit;
        },
        _rule() {
          return {
            min: config.min > 1 ? config.min : 1,
            max: config.max != null ? config.max : null,
            step: config.step > 1 ? config.step : 1
          };
        },
        _clearErrorMessage(id) {
          this.hasError = false;
          Alpine.store('xQuickOrderList').setErrorLine(id, false);
          document.getElementById(`LineItemError-${id}`)?.classList.add('hidden');
          document.getElementById(`LineItemErrorMobile-${id}`)?.classList.add('hidden');
        },
        _addErrorMessage(id, message) {
          const errorElements = [
            document.getElementById(`LineItemError-${id}`),
            document.getElementById(`LineItemErrorMobile-${id}`)
          ];
          if (errorElements.some((el) => !el)) return;
          this.hasError = true;
          Alpine.store('xQuickOrderList').setErrorLine(id, true);
          errorElements.forEach((el) => {
            el.classList.remove('hidden');
            el.getElementsByClassName('cart-item__error-text')[0].innerHTML = message;
          });
        },
      }));
    });
  });
}
